<link rel="preload" as="image" href="./../../../../assets/img/booster-pages/import_export_to_us.webp">

<div class="booster--page--wrapper">

    <section class="booster--page--hero">

        <div class="container">
            <div class="booster--page--hero--start">
                <div class="booster--page--hero--left">
                    <h1 class="booster--page--hero--title">
                        Shipping to the United States (U.S.A.)
                    </h1>
                    <div class="booster--page--hero--pill">
                        <p>
                            Ship now from $12.45
                        </p>
                    </div>
                </div>

                <div class="booster--page--hero--image">
                    <img src="./../../../../assets/img/booster-pages/import_export_to_us.webp"
                        alt="parcel package shipping to united states" class="hero--image" fetchpriority="high">
                </div>
            </div>

            <div class="booter--page--hero--shipping--cost--calculator--wrapper">
                <div class="booter--page--hero--shipping--cost--calculator">

                    <div class="shipping--cost--calculator--head">
                        <h4>
                            Try Our Shipping Cost Calculator
                        </h4>
                    </div>

                    <div class="shipping--cost--calculator--calculator" [formGroup]="shippingCalcForm" ngNativeValidate>

                        <div class="calculator--form--element calculator--from-country">
                            <label for="">From</label>
                            <div class="select--wrapper bg-white b-rad-5">
                                <i class="fas fa-chevron-down"
                                    style="position: absolute; right: 5px; top: 9px;float: right; color: #222222; border-radius: 32%; padding: 7px; font-size: 12px;"
                                    aria-hidden="true"></i>
                                <select formControlName="fromCountry"
                                    style="-webkit-appearance: none;-moz-appearance: none;appearance: none;width: 100%; border-radius: 5px;padding:10px 15px !important;height: 43px;"
                                    class="form-select  <strong>Shippn</strong>-input" class="form-control-sm"
                                    aria-label=".form-select-lg example">
                                    <option value="" disabled>Please Select</option>
                                    <option *ngFor="let country of hostCountries;" value="{{country.code}}">
                                        <span
                                            *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                                        <span *ngIf="country.code == 'TR' || country.name == 'Turkey'"
                                            translate="no">Türkiye</span>
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="calculator--form--element calculator--to--country">
                            <label for="">To</label>
                            <div class="select--wrapper bg-white b-rad-5">
                                <i class="fas fa-chevron-down"
                                    style="position: absolute; right: 5px; top: 9px;float: right; color: #222222; border-radius: 32%; padding: 7px; font-size: 12px;"
                                    aria-hidden="true"></i>
                                <select formControlName="toCountry"
                                    style="-webkit-appearance: none;-moz-appearance: none;appearance: none;width: 100%; border-radius: 5px;padding:10px 15px !important;height: 43px;"
                                    class="form-select  <strong>Shippn</strong>-input" class="form-control-sm"
                                    aria-label=".form-select-lg example">
                                    <option *ngFor="let country of allCountries;" value="{{country.code}}">
                                        <span
                                            *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                                        <span *ngIf="country.code == 'TR' || country.name == 'Turkey'"
                                            translate="no">Türkiye</span>
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="calculator--form--element calculator--parcel--weight"
                            style="align-items: flex-start;">
                            <label for="" style="margin-top: 10px">
                                Weight:
                            </label>


                            <div class="form--element--group flow--column">
                                <input type="number" class="form-control calculator--input" min="0"
                                    placeholder="Parcel Weight?" formControlName="parcelWeight" onwheel="this.blur()">
                                <div class="weight-unit" style="padding: 3px 10px">
                                    <label style="font-size: 16px;font-weight: 300;" class="radio-inline">
                                        <input formControlName="weightUnit" type="radio" name="weightUnit" value="lbs"
                                            class="ng-pristine ng-valid ng-not-empty ng-touched"> lbs
                                    </label>
                                    <label style="margin-left: 10px;font-size: 16px;font-weight: 300;"
                                        class="radio-inline">
                                        <input formControlName="weightUnit" type="radio" name="weightUnit" value="kg"
                                            class="ng-pristine ng-untouched ng-valid ng-not-empty"> kg
                                    </label>
                                </div>
                            </div>

                        </div>

                        <div class="calculator--form--element calculator--calculate">
                            <button class="btn shippn-from-to-area-go-btn" (click)="calculatePrice()">Calculate</button>
                        </div>

                    </div>



                </div>
            </div>
        </div>
        <div class="custom-shape-divider-bottom-1683291526">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                preserveAspectRatio="none">
                <path
                    d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
                    opacity=".25" class="shape-fill"></path>
                <path
                    d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
                    opacity=".5" class="shape-fill"></path>
                <path
                    d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
                    class="shape-fill"></path>
            </svg>
        </div>
    </section>


    <section class="section booster--page--section cheapest-shipping-section" id="booster--calculation--result">

        <div class="container">
            <h3>Cheapest shipping to the U.S.A.</h3>

            <div *ngIf="hasCourierOptions" style="margin-top: 20px;transition: 1s; padding:0;"
                class="container shippn-homepage-container">
                <div class="row">
                    <div class="col-md-12" style="padding:0">
                        <div
                            style="background-color: #f4f4f4; padding: 20px ;border-radius: 5px;box-shadow: 5px 5px 10px rgb(0 0 0 / 20%);">
                            <div class="table-responsive">
                                <table class="table table-borderless">
                                    <thead>
                                        <tr style="border-bottom: 1px solid #70707036;">
                                            <th style="font-size: 22px;" colspan="4">
                                                Courier Options

                                            </th>
                                        </tr>
                                        <tr style="border-bottom: 1px solid #70707036;">
                                            <th scope="col">Company</th>
                                            <th scope="col">Service Type</th>
                                            <th scope="col">Estimated Delivery Time</th>
                                            <th scope="col">Price (including host fee)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of courierData;">
                                            <td>
                                                <img *ngIf="data.company_id == 1" style="width: 65px;"
                                                    src="../../assets/tnt.png" alt="tnt logo">
                                                <img *ngIf="data.company_id == 2" style="width: 65px;"
                                                    src="../../assets/ups.png" alt="ups logo">
                                                <img *ngIf="data.company_id == 3" style="width: 65px;"
                                                    src="../../assets/dhl.png" alt="dhl logo">
                                                <img *ngIf="data.company_id == 4" style="width: 65px;"
                                                    src="../../assets/fedex.png" alt="fedex logo">
                                                <img *ngIf="data.company_id == 5" style="width: 65px;"
                                                    src="../../assets/auspost.png" alt="auspost logo">
                                                <img *ngIf="data.company_id == 6" style="width: 65px;"
                                                    src="../../assets/usps.png" alt="usps logo">
                                                <img *ngIf="data.company_id == 7" style="width: 65px;"
                                                    src="../../assets/aramex.png" alt="aramex logo">
                                                <img *ngIf="data.company_id == 8" style="width: 65px;"
                                                    src="../../assets/laposte.png" alt="laposte logo">
                                                <img *ngIf="data.company_id == 12" style="width: 65px;"
                                                    src="../../assets/ems.png" alt="Shippn Partner EMS logo">
                                                <img *ngIf="data.company_id == 13" style="width: 65px;"
                                                    src="../../assets/dpd.png" alt="Courier DPD logo">
                                                <img *ngIf="data.company_id == 14" style="width: 60px;"
                                                    src="../../assets/evri.webp" alt="Courier Evri logo">
                                            </td>
                                            <td>{{data.service_type_name}}</td>
                                            <td>{{data.estimated_delivery}} Business Days</td>
                                            <td style="font-weight: bold;" translate="no">{{data.total_shipment_amount}}
                                                USD</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="booster--page--cta--wrapper" *ngIf="hasCourierOptions">
                <button class="btn shippn-from-to-area-go-btn shippn-white-btn" (click)="goToShopFrom()">
                    Ship Now!
                </button>
            </div>


        </div>
        <div class="custom-shape-divider-bottom-1683306382">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                preserveAspectRatio="none">
                <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
                    class="shape-fill"></path>
            </svg>
        </div>

    </section>

    <section class="section booster--page--section import--and--export--section"
        style="margin-bottom: 0; padding-bottom: 20px;">
        <div class="container">

            <h4>
                Shipping to United States (Import and Export to the U.S.A.)
            </h4>

            <p>
                If you want to ship goods to the United States from different countries or you need shop over the
                internet from overseas, <strong>Shippn</strong> can provide you with
                great courier services at affordable prices. <strong>Shippn</strong> can help you import your parcels
                from UK, Germany,
                France, Australia or any other countries.
                Whether you are importing to the U.S.A. or exporting to the U.S.A., <strong>Shippn</strong> cost calculator
                finds you the best
                shipping quotes from anywhere in the world.
                <strong>Shippn</strong> makes it easy to shop from Europe or Asia and bring your purchases to the United
                States with
                discounted shipping rates and reputable carriers
                Like DHL, FedEx and UPS.

            </p>

            <p>
                If you would like to find a courier to import goods to the U.S.A., <strong>Shippn</strong> can provide you
                with the best
                shipping options available. If you also need package
                consolidation services, <strong>Shippn</strong> hosts can help you for package handling and
                consolidation.

            </p>


            <div class="importing--goods--wrapper">
                <div class="importing--goods--left">
                    <h4>
                        Importing goods to the U.S.A.
                    </h4>
                    <p>

                        If you want to purchase an item online from overseas, you need a courier service who will help
                        with
                        shipping and customs clearance.
                        <strong>Shippn</strong>’s international shipping services, together with
                        <strong>Shippn</strong>’s hosts are the perfect solution
                        for
                        shopping online from overseas. <strong>Shippn</strong>’s courier partners
                        handle import processes for you while <strong>Shippn</strong>’s customer service are ready to
                        help with any
                        issues during
                        customs clearance.

                    </p>
                    <div class="booster--page--cta--wrapper">
                        <button class="btn shippn-from-to-area-go-btn shippn-box-shadow" (click)="goToShopFrom()">
                            Ship Now!
                        </button>
                    </div>
                </div>
                <div class="importing--goods--right">
                    <img src="../../../../assets/img/booster-pages/import.webp"
                        alt="parcel import to united states of america">
                </div>
            </div>

            <div class="exporting--goods--wrapper">
                <div class="exporting--goods--left">
                    <img src="../../../../assets/img/booster-pages/export.webp"
                        alt="parcel export to united states of america">
                </div>
                <div class="exporting--goods--right">
                    <h4>
                        Exporting goods to the U.S.A.
                    </h4>
                    <p>
                        If you are an online seller and need to ship your items to your customers in the U.S.A., sign up as
                        a host
                        at <strong>Shippn</strong> and quickly ship your items with discounted
                        shipping rates using world class courier services like DHL, FedEx, TNT, UPS and DPD. Select the
                        delivery
                        times that suits your needs and take advantage of
                        creating your shipping labels right from your <strong>Shippn</strong> dashboard. You can pay for
                        shipping charges
                        with
                        your credit card while earning bonuses as a <strong>Shippn</strong> host
                        for each shipment you complete with <strong>Shippn</strong>. Use <a
                            [routerLink]="['/shipping-cost-calculator']"><strong>Shippn</strong>’s Cost Calculator
                            now</a> to estimate your
                        shipping
                        costs by entering the country you are shipping from and
                        the weight and dimensions of your package. <strong>Shippn</strong> will provide you with a list
                        of carriers with
                        optional
                        delivery times and an instant shipping quote.

                    </p>
                    <div class="booster--page--cta--wrapper">
                        <button class="btn shippn-from-to-area-go-btn shippn-box-shadow" (click)="goToShopFrom()">
                            Ship Now!
                        </button>
                    </div>
                </div>
            </div>






            <h4>
                Fast and Convenient Shipping Options
            </h4>

            <p>

                We offer a range of fast and convenient shipping options for customers shipping to the US, including
                express and standard shipping options.
                We work with a variety of reputable carriers to ensure that your package is delivered quickly and
                safely.

            </p>


            <h4>
                US Couriers you can use with <strong style="color: #ff6c36;">Shippn</strong>
            </h4>
            <p>
                Whether you are importing or exporting to the U.S.A., you can use <strong>Shippn</strong> carriers fast and
                reliable services with standard or priority shipping options.
                Here are the best shipping carriers you can utilize with <strong>Shippn</strong>:
                <br><br>
                <strong>DHL Express</strong> - Ship a parcel to U.S.A. with DHL Express’s standard service from any country
                in the world in
                2-5 business days
                <br><br>

                <strong>FedEx Priority Express</strong> - FedEx Priority Express is available in more than 85 countries
                to ship to the
                U.S.A.. Priority service is the top selection among FedEx’s service options.
                <br><br>
                <strong>UPS Express Saver </strong> - Ship to the US with UPS Express Saver service for low cost
                shipping and to get
                advantage of UPS’s vast coverage in the U.S.A..
                <br>
                <br>
            </p>


            <h4>
                Special Considerations
            </h4>

            <p>
                Please note that there may be restrictions on the types of products that can be shipped to the US, and
                we encourage you to review our shipping guidelines
                before making a purchase. We also offer additional services such as package consolidation, which can
                help you save on shipping costs by combining multiple
                packages into a single shipment.

            </p>
        </div>

    </section>


    <section class="section booster--page--section" style="margin-top: 0; padding-top: 0;">
        <div class="container">
            <h4>Benefits of Shipping to the U.S.A. with <a style="color:#ff6c36"
                    href="https://www.shippn.com"><strong>Shippn</strong>.com</a></h4>

            <ul style="font-size: 16px;">
                <li>
                    <strong>Affordable shipping rates</strong>
                </li>
                <li>
                    <strong>Fast delivery times</strong>
                </li>
                <li>
                    <strong>Easy tracking and monitoring</strong>
                </li>
                <li>
                    <strong>Secure packaging and handling</strong>
                </li>
                <br>
            </ul>

            <p>
                Are you looking to ship to the U.S.A.? At <a href="https://shippn.com"><strong>Shippn</strong>.com,</a> we
                offer fast, reliable, and
                affordable shipping
                services that can help you get your goods to the U.S.A. quickly and easily.
                Whether you're shipping personal items or commercial products, we have a solution that can meet your
                needs.

            </p>


        </div>

        <div class="booster--page--cta--wrapper">
            <button class="btn shippn-from-to-area-go-btn shippn-box-shadow" (click)="goToShopFrom()">
                Ship Now!
            </button>
        </div>
    </section>

    <section class="booster--page--section" style="padding-top:0;">
        <div class="container">
            <h4>Customs Requirements</h4>
            <p>
                When you prepare your shipment with <strong>Shippn</strong>, you will enter information about the
                contents of your
                shipment. Using this information, <strong>Shippn</strong> will automatically create
                your customs documents, required by US Customs Authorities and you will be able to print these documents
                along with your shipping label. You can attach these documents
                to your package and when the courier comes to your location to pick up your package, your package will
                be ready with all required documents and information.

            </p>
            <br>

            <h4>
                Prohibited Items
            </h4>
            <p>
                The most common question in shipping items internationally is "Which items are prohibited to ship
                internationally?"
            </p>
            <p>
                We have put together guidelines for shipping to the U.S.A. and a list of prohibited items:
            </p>
            <p>
                <strong>Prohibited Goods</strong>:
            </p>
            <div>
                <strong>Agricultural Materials</strong> <br>
                Because burlap or jute bagging may harbor the Khapra Beetle, such articles are regulated when arriving
                from countries where this pest is endemic.
                <br>
                If the burlap or jute is arriving from, transited, or originated in:
                <ul style="
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    gap: 30px;
                    margin: 15px 0 30px; font-weight: 500;">
                    <li>
                        Afghanistan
                    </li>
                    <li>
                        Algeria
                    </li>
                    <li>
                        Bangladesh
                    </li>
                    <li>
                        Burkina Faso
                    </li>
                    <li>
                        Cyprus
                    </li>
                    <li>
                        Egypt
                    </li>
                    <li>
                        India
                    </li>
                    <li>
                        Iran
                    </li>
                    <li>
                        Iraq
                    </li>
                    <li>
                        Israel
                    </li>
                    <li>
                        Libya
                    </li>
                    <li>
                        Mali
                    </li>
                    <li>
                        Mauritania
                    </li>
                    <li>
                        Morocco
                    </li>
                    <li>
                        Myanmar
                    </li>
                    <li>
                        Niger
                    </li>
                    <li>
                        Nigeria
                    </li>
                    <li>
                        Pakistan
                    </li>
                    <li>
                        Saudi Arabia
                    </li>
                    <li>
                        Senegal
                    </li>
                    <li>
                        Sri Lanka
                    </li>
                    <li>
                        Sudan
                    </li>
                    <li>
                        Syria
                    </li>
                    <li>
                        Tunisia
                    </li>
                    <li>
                        Türkiye
                    </li>
                </ul>
                then the shipment will require a WRITTEN PERMIT and T306-c-1 or T306-c-2 (as per 7 CFR 319.75).
                <br><br>
            </div>
            <p>
                <strong>Alcoholic Beverages</strong>
                <br>

                The Receiver must be licensed and authorized to receive the alcoholic beverages (beer & wine).
                US does not support international shipments of spirits / liquor.
                <br>
                <br>
            </p>
            <p>
                <strong>Antiques</strong> <br>
                Antique shipments are restricted from Europe, the Middle East and Africa and can only be shipped with an
                International Special Commodities (ISC) contract. Antiques are defined as a work of art, piece of
                furniture, decorative object, or silverware that is 100 years old or older.
                <br> <br>
            </p>
            <p>
                <strong>Artwork</strong> <br>
                Artwork shipments are restricted from Europe, the Middle East and Africa and can only be shipped with an
                International Special Commodities (ISC) contract.
                <br><br>
                Paintings or other works of art can be accepted if the artist is still alive, the artwork is replaceable
                and an art dealer or gallery has appraised the artwork within the last year. If the declared value of
                the artwork is greater than $100.00 and there is a claim, the shipper must provide a copy of the
                original invoice, a bill of sale, or other proof certifying in writing the actual cost or replacement
                cost of the item.
                <br><br>
                Artwork includes the following: Original engravings, prints, lithographs, original sculptures, statuary.
                <br><br>
                The term "Artwork" does not apply to: architectural, engineering, industrial, topographical, commercial
                drawings, hand-painted or hand-decorated manufactured articles.
                <br><br>
            </p>

            <p>
                <strong>Batteries</strong> <br>
                <br>
                In all cases, batteries must be shipped with positive short-circuit protection, such as insulating caps
                on the terminals.
                <br>
                Lead-acid batteries <br>
                Lithium and lithium ion batteries <br>
                Both rechargeable & non-rechargeable power sources, common in computers, cell phones, cameras & other
                small electronic devices. If dropped, crushed or short-circuited, these batteries can release dangerous
                amounts of heat & may ignite, & are dangerous in fires.
                <br>
                <br>
                Special regulations apply to shipping these batteries.Shipments requiring hazardous materials shipping
                papers are accepted from contract hazmat shippers only & certain lithium batteries may not be accepted.
                <br>
                <br>
                Dry cell batteries
                <br>
                These batteries are not subject to the Dangerous Goods Regulations, provided they are positively
                protected against short circuit, such as being contained in a retail blister pack to prevent contact
                with the terminals, or singly packaging each battery in a small plastic bag, or taping the terminals,
                etc.
                <br>
            </p>

            <p>
                <strong>Beer</strong> <br>
                Personal shipments of wine, beer and alcohol are strictly prohibited
            </p>
            <p>
                <strong>Electronic Cigarette</strong>
                <br>
                Electronic cigarettes and the flavor for the electronic cigarettes can only be shipped with an
                International Special Commodities (ISC) contract.
                <br>
                Please refer to the US FDA website for additional information on E-Cigarettes and Products
                <br>
                <a href="http://www.fda.gov/NewsEvents/PublicHealthFocus/ucm172906.htm" target="_blank"
                    style="color:#222222;font-weight: 500; text-decoration: underline; word-break: break-all;">http://www.fda.gov/NewsEvents/PublicHealthFocus/ucm172906.htm</a>
                <br><br>
            </p>

            <p>
                <strong>High Intensity Discharge (HID) Lights</strong> <br>
                Certain HID conversion kits of vehicle headlights and taillights are prohibited from importation into
                the U.S
                <br>

                If the headlamps are capable of being installed and used in motor vehicles subject to the Federal Motor
                Vehicle Standards (i.e., "conventional 'on-road' or 'off-road' vehicles), they must comply with Standard
                No.108 in order to be imported. More information regarding the requirements described in Standard No.108
                can be found in the Federal Regulation 49CFR571.108.

                <br>
                Also, more information can be found on the website for the U.S. Department of Transportation, Federal
                Highway Administration at <a href="http://www.fhwa.dot.gov/" target="_blank"
                    style="color:#222222; font-weight: 500;text-decoration: underline;word-break: break-all;">http://www.fhwa.dot.gov/</a>

            </p>

            <p>
                <strong>High Powered Lasers</strong> <br>
                (1,000 milli watts or greater) Imported laser pointers may not emit a Class lll b or class IV visible
                beam. Pointers are limited to Class llla or below (class lla, ll, or l ). The upper power limit for
                Class lll a is 5 milliwatts (mW), the legal limit (21 CFR 1040.11(b))
                <br>
            </p>

            <p>
                <strong>Jewelry</strong> <br>
                Shipments of jewelry can be shipped as long as the value does not exceed US$500.00 or the local currency
                equivalent per package.
                <br>
                Jewelry for which the retail price is lower than US$150.00 per item and which do not contain precious
                metal(s) and/or stone(s) are considered costume jewelry and can be shipped only up to this value from
                the origin country.
                <br>
            </p>

            <p>
                <strong>Kinder Chocolate Eggs</strong> <br>
                Kinder Chocolate Eggs are banned for sale and import into the United States. The toy hidden in the
                Kinder Egg poses a choking and aspiration hazard in children under the age of three. The Kinder Eggs are
                hollow milk chocolate eggs about the size of a large hen's egg packaged in a colorful foil paper. The
                toy within the egg is contained in an oval-shaped plastic capsule. The toy requires assembly and each
                egg contains a different toy.
                <br>
                <br>

                U.S. Consumer Product Safety Commission determined that the product failed to meet small parts
                requirements with respect to children less than three years of age.
                <br>
            </p>

            <p>
                <strong>Lottery Tickets</strong> <br>
                United States Customs & Border Protection prohibits the importation of any lottery ticket and has the
                right to destroy material, including printed material, for use in a lottery.
                <br>
            </p>

            <p>
                <strong>Negotiable Bonds, Drafts</strong> <br>
                You may not import negotiable bonds or drafts.
                <br>
            </p>
            <p>
                <strong>Personal Effects </strong><br>
                Personal Effects are classified as used items (owned for a minimum of 6 months) intended for the
                consignee's personal use. Any items intended for any other use, such as wholesale or retail sales,
                business purposes, or for distribution are not considered personal effects and cannot be shipped on this
                basis. "Personal Effects" must be clearly stated on the invoice and goods description. Note: Personal
                effects include Items that an individual has owned prior to a foreign travel/trip.
                <br>
                <br>
                The description on the invoice should include the purchase date (month/year). For properly declared
                personal effects, no duties or taxes will be assessed by the U.S. government, but a Brokerage surcharge
                may apply.

                <br>
                <br>
                Personal effects shipments may experience a delay for additional Customs processing.
                <br>
                <br>
                Prohibited articles cannot be accepted as personal effects.
                <br>

            </p>

            <p>
                <strong>Products Made in Iran</strong> <br>
                Imports from Iran Customs and Border Protection (CBP) prohibits the direct or indirect importation into
                the U.S. any article that is the product of Islamic Republic of Iran.
                <br>
                U.S. persons and companies that currently import food and carpets from Iran should be aware of the
                guidance issued July 1, 2010, by the Office of Foreign Assets Control (OFAC) concerning a change in U.S.
                law made by the Comprehensive Iran Sanctions, Accountability, and Divestment Act of 2010 ("CISADA").
                OFAC's Iranian Transactions Regulations currently contain a general license authorizing the importation
                into the U.S. of foodstuffs from Iran that are classified under chapters 2-23 of the Harmonized Tariff
                Schedule of the United States (HTS) such as pistachios and non-beluga caviar (which is prohibited by
                other aspects of law).
                <br>
                <br>
                In addition, the importation of carpets and other textile floor coverings of Iranian origin that are
                classified under chapter 57 or heading 9706.00.0060 of the HTS are also authorized.

                <br>
                <br>

                However, due to the additional Iran sanctions recently passed by Congress, OFAC will soon issue a
                regulation amending the Iranian Transaction Regulations to eliminate the general license and such
                imports will be no longer permitted starting on September 29, 2010. OFAC has also indicated that any
                authorized Iranian products must be imported by September 28, 2010 and it will not issue any specific
                licenses authorizing any imports after that date. As a result, importers must move quickly to ensure
                that any pending orders are entered for consumption by their customs brokers by September 28, 2010.
                <br>
            </p>

            <p>
                <strong>Rosewood</strong> <br>
                The Convention on International Trade in Endangered Species (CITES) added all 250 species of rosewood to
                a restricted list requiring permits proving legal sourcing on international shipments of both raw
                materials and finished goods containing rosewood (e.g., furniture, musical instruments, car interiors)
                effective January 2, 2017.
                <br>
                CITES is an international treaty to prevent species from becoming endangered or extinct because of
                international trade
                Louisville, Kentucky, is NOT a designated USDA port for processing CITES-permitted shipments
                The USDA does not have the authority to allow shipments containing rosewood to clear through
                non-designated ports.

            </p>

            <p>
                <strong>Seeds</strong> <br>
                Shipments of seeds may require a United States Department of Agriculture (USDA) Plant Protection and
                Quarantine (PPQ) Permit or Phytosanitary Certificate. Inspection by the USDA is required.
                <br>
            </p>

            <p>
                <strong>Swords</strong> <br>
                Note: It is the shipper's responsibility to comply with government regulations or laws in each country.
                Shipments are subject to inspection and possible delays.
                <br>
                <br>
                If a customer would like to import a sword for recreational use or as a collector, they must be approved
                by the International Special Commodities (ISC) prior to shipping the sword.
                <br>

            </p>

            <p>
                <strong>Value Limit: 800.00 US Dollar (USD)</strong>

                <br>
                When the value of the shipment is equal to or less than the De minimis value ($800 US Dollar), the
                shipment may enter the country or territory duty and tax free, with the exception of shipments
                containing certain PGA regulated commodities, those subject to anti-dumping/countervailing, and Tariff
                Rate Quota.
                <br>

            </p>


        </div>

        <div class="booster--page--cta--wrapper">
            <button class="btn shippn-from-to-area-go-btn shippn-box-shadow" (click)="goToShopFrom()">
                Ship Now!
            </button>
        </div>
    </section>








</div>

<script type="application/ld+json">
    { 
        "@context": "http://schema.org",
        "@graph": [
                                {
                    "@type": "Product",
                    "name": "Shipping to U.S.A.",
                                                "aggregateRating":{
                            "@type": "AggregateRating",
                            "ratingValue": "4.5",
                            "reviewCount": "79"
                        },
                                            "description" : "Send a parcel to the U.S.A. and import to the US cheaply with Shippn. Book discounted services with DHL, UPS, Fedex and more.",
                                                "offers": {
                            "@type": "AggregateOffer",
                            "priceCurrency" : "USD",
                            "lowPrice": "8.85",
                            "availability" : "http://schema.org/InStock"
                        },
                                            "brand": {
                        "@type": "Brand",
                        "name": "Shippn"
                    }
                },
                                                                                    {
                    "@type": "https://schema.org/ParcelService",
                    "name": "Fedex",
                                                "image": "https://www.shippn.com/assets/fedex.png",
                                            "description": "2-8 business days - from 8.85"
                },                                                        {
                    "@type": "https://schema.org/ParcelService",
                    "name": "DHL",
                                                "image": "https://www.shippn.com/assets/dhl.png",
                                            "description": "2-3 business days - from 9.92"
                },                                                        {
                    "@type": "https://schema.org/ParcelService",
                    "name": "UPS",
                    "image": "https://www.shippn.com/assets/dhl.png",
                                            "description": "1-5 business days - from 17.93"
                }                   
                        ]
    }
</script>